var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSearchCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1426 4.92041L4.85718 11.2058",
    stroke: "#727272",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1426 11.2058L4.85719 4.92042",
    stroke: "#727272",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSearchCancel);
export default __webpack_public_path__ + "static/media/ico-search-cancel.84ff9a40836898c9ab465c96a7612190.svg";
export { ForwardRef as ReactComponent };